import React from 'react';

const NO_OP = () => undefined;

function addAll(files, dt) {
	for(let i = 0; i < files.length; i++) {
		dt.items.add(files[i]);
	}
}

function getValue(maxSize, files, oldFiles) {
	if(maxSize && files?.length) {
		const filtered = Array.prototype.filter.call(files, file => file.size < maxSize);
		if(filtered.length !== files.length) {
			const dt = new DataTransfer();
			if(oldFiles?.length) {
				addAll(oldFiles, dt);
			}
			for(const file of filtered) {
				dt.items.add(file);
			}
			return dt.files;
		}
	}
	if(oldFiles?.length) {
		const dt = new DataTransfer();
		addAll(oldFiles, dt);
		addAll(files, dt);
		return dt.files ?? files;
	}
	return files;
}

export function useChange(onChange, maxSize, oldFiles) {
	if(!onChange) {
		return NO_OP;
	}
	return files => {
		onChange({ target: { value: getValue(maxSize, files, oldFiles) } });
	};
}

export default function FileInput({ value, onChange, maxSize, ...props }) {
	const change = useChange(onChange, maxSize);
	NO_OP(value);
	return <input {...props} onChange={e => change(e.target.files)} />;
}
